
import { defineComponent } from 'vue';

import NotificationWrapper from './NotificationWrapper.vue';
import { useNotification } from './useNotification';

export default defineComponent({
  name: 'NotificationDialog',
  components: {
    NotificationWrapper,
  },
  props: {
    withHeader: {
      type: Boolean,
      required: false,
      default: true,
    },
    withFooter: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup() {
    const { collapseNotificationModal } = useNotification();
    return { collapseNotificationModal };
  },
});
